// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc */
/* eslint-disable ta-code-conventions/has-matching-test */
import React from 'react';
import { globalize, localize } from '@ta/common.i18n';

type Props = {
  /** display date for UGC */
  dateStr: ?string,
};

/**
 * The date comes in as a string from the server, sometimes in the format "2018-09-18" (i.e. a published date,
 * which has no timezone but is in Eastern time from our servers), and sometimes "2018-09-18T18:43:03.592Z"
 * (i.e. a creation date, in UTC per the Z). If it's just converted to a JS Date object and displayed, the
 * date-only formats will always display as the day before, because the Date constructor interprets them as
 * midnight GMT, i.e. 2018-09-18 00:00:00 GMT, and then that is displayed in the browser's time zone,
 * which if it's EST will always be earlier.
 */
export const getDateInBrowserTimezone = (dateStr: string) => {
  if (dateStr) {
    const date = new Date(dateStr);
    if (dateStr.length < 11) {
      // no time info, so it was parsed as UTC midnight, but display will adjust
      // for local time, so correct for browser timezone
      date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
    }
    return date;
  }
  return null;
};

/**
 * Function that converts an ISO date string into a user-friendly string.
 */
export const getDisplayDate = (dateStr: string) => {
  const currentDate = new Date();
  const displayDate = getDateInBrowserTimezone(dateStr);
  if (!displayDate) return null;

  if (
    displayDate.getFullYear() === currentDate.getFullYear() &&
    displayDate.getMonth() === currentDate.getMonth()
  ) {
    if (displayDate.getDate() === currentDate.getDate()) {
      return localize('social_publish_date_Today');
      /** Today */
    } else if (displayDate.getDate() === currentDate.getDate() - 1) {
      return localize('social_publish_date_Yesterday');
      /** Yesterday */
    }
    return globalize.formatDate('date_medium_month', displayDate);
    /** day and month */
  }

  return globalize.formatDate('date_medium_month_year', displayDate);
  /** month and year */
};

/**
 * Simple component to display a user friendly date string.
 */
export class ContentDisplayDate extends React.PureComponent<Props> {
  render() {
    const { dateStr } = this.props;
    if (!dateStr) return null;

    return getDisplayDate(dateStr);
  }
}
